import * as THREE from 'three';

function getObjectWorldPivot (object) {
  object.updateMatrixWorld(true);

  if (object.geometry) {
    if (!object.geometry.boundingSphere) {
      object.geometry.computeBoundingSphere();
    }

    if (object.geometry.boundingSphere) {
      return object.geometry.boundingSphere.center.clone().applyMatrix4(object.matrixWorld);
    }
  }

  const bounds = new THREE.Box3().setFromObject(object);
  if (!bounds.isEmpty()) {
    return bounds.getCenter(new THREE.Vector3());
  }

  return object.getWorldPosition(new THREE.Vector3());
}

function moveObjectByWorldDelta (object, deltaWorld) {
  const targetWorldPosition = object.getWorldPosition(new THREE.Vector3()).add(deltaWorld);

  if (object.parent) {
    object.parent.updateMatrixWorld(true);
    object.position.copy(object.parent.worldToLocal(targetWorldPosition));
  } else {
    object.position.copy(targetWorldPosition);
  }

  object.updateMatrixWorld(true);
}

function moveObjectPivotToWorldPosition (object, pivotWorldPosition) {
  const currentPivot = getObjectWorldPivot(object);
  moveObjectByWorldDelta(object, pivotWorldPosition.clone().sub(currentPivot));
}

function applyObjectUpdateAroundPivot (object, updateObject) {
  const pivotBefore = getObjectWorldPivot(object);
  updateObject();
  object.updateMatrixWorld(true);
  const pivotAfter = getObjectWorldPivot(object);
  moveObjectByWorldDelta(object, pivotBefore.sub(pivotAfter));
}

function applyPivotRelativeTransform (object, transform) {
  if (transform.position) {
    moveObjectPivotToWorldPosition(object, new THREE.Vector3(
      transform.position.x,
      transform.position.y,
      transform.position.z
    ));
  }

  if (transform.rotation) {
    applyObjectUpdateAroundPivot(object, () => {
      object.rotation.set(transform.rotation.x, transform.rotation.y, transform.rotation.z);
    });
  }

  if (transform.scale) {
    applyObjectUpdateAroundPivot(object, () => {
      object.scale.set(transform.scale.x, transform.scale.y, transform.scale.z);
    });
  }
}

export {
  applyObjectUpdateAroundPivot,
  applyPivotRelativeTransform,
  getObjectWorldPivot,
  moveObjectPivotToWorldPosition
};
